import React from 'react';
import {
  FormGroup,
  FormInput,
  Slider,
  AdvancedColorInput,
  ToggleSwitch,
  NavButtons,
} from '../common';

const ProviderIcon = ({ provider }) => {
  switch (provider) {
    case 'apple':
      return (
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          role="img"
          aria-hidden="true"
        >
          <path
            fill="currentColor"
            d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701"
          />
        </svg>
      );
    case 'google':
      return (
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          role="img"
          aria-hidden="true"
        >
          <path
            fill="currentColor"
            d="M18.316 5.684H24v12.632h-5.684V5.684zM5.684 24h12.632v-5.684H5.684V24zM18.316 5.684V0H1.895A1.894 1.894 0 0 0 0 1.895v16.421h5.684V5.684h12.632zm-7.207 6.25v-.065c.272-.144.5-.349.687-.617s.279-.595.279-.982c0-.379-.099-.72-.3-1.025a2.05 2.05 0 0 0-.832-.714 2.703 2.703 0 0 0-1.197-.257c-.6 0-1.094.156-1.481.467-.386.311-.65.671-.793 1.078l1.085.452c.086-.249.224-.461.413-.633.189-.172.445-.257.767-.257.33 0 .602.088.816.264a.86.86 0 0 1 .322.703c0 .33-.12.589-.36.778-.24.19-.535.284-.886.284h-.567v1.085h.633c.407 0 .748.109 1.02.327.272.218.407.499.407.843 0 .336-.129.614-.387.832s-.565.327-.924.327c-.351 0-.651-.103-.897-.311-.248-.208-.422-.502-.521-.881l-1.096.452c.178.616.505 1.082.977 1.401.472.319.984.478 1.538.477a2.84 2.84 0 0 0 1.293-.291c.382-.193.684-.458.902-.794.218-.336.327-.72.327-1.149 0-.429-.115-.797-.344-1.105a2.067 2.067 0 0 0-.881-.689zm2.093-1.931l.602.913L15 10.045v5.744h1.187V8.446h-.827l-2.158 1.557zM22.105 0h-3.289v5.184H24V1.895A1.894 1.894 0 0 0 22.105 0zm-3.289 23.5l4.684-4.684h-4.684V23.5zM0 22.105C0 23.152.848 24 1.895 24h3.289v-5.184H0v3.289z"
          />
        </svg>
      );
    case 'outlook':
      return (
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          role="img"
          aria-hidden="true"
        >
          <path
            fill="currentColor"
            d="M3.5 5.25A2.25 2.25 0 0 1 5.75 3h12.5A2.75 2.75 0 0 1 21 5.75V9l-9 5.625L3 9.01v5.24A2.75 2.75 0 0 0 5.75 17h12.5A2.75 2.75 0 0 0 21 14.25V21h-2.5A2.5 2.5 0 0 1 16 18.5v-.257l-2.372 1.482c-.856.535-1.934.535-2.79 0L3 15.75V5.25zM9.5 10a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm0 1.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
          />
        </svg>
      );
    case 'yahoo':
      return (
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          role="img"
          aria-hidden="true"
        >
          <text
            x="12"
            y="14"
            textAnchor="middle"
            dominantBaseline="middle"
            fontSize="13"
            fontFamily="Arial, sans-serif"
            fontWeight="700"
          >
            Y!
          </text>
        </svg>
      );
    default:
      return null;
  }
};

const providerOptions = [
  {
    key: 'apple',
    label: 'Apple Calendar',
    helper: 'Downloads an .ics file for Apple Calendar and most desktop apps.',
    color: '#111827',
  },
  {
    key: 'google',
    label: 'Google Calendar',
    helper: 'Opens Google Calendar in a new tab.',
    color: '#0B57CF',
  },
  {
    key: 'outlook',
    label: 'Outlook.com',
    helper: 'Creates an event on Outlook.com.',
    color: '#2563EB',
  },
  {
    key: 'yahoo',
    label: 'Yahoo Calendar',
    helper: 'Creates an event in Yahoo Calendar.',
    color: '#6001D2',
  },
];

const providerImageKeys = {
  apple: 'calendarApple',
  google: 'calendarGoogle',
  outlook: 'calendarOutlook',
  yahoo: 'calendarYahoo',
};

const defaultProviders = {
  apple: true,
  google: true,
  outlook: false,
  yahoo: false,
};

const CalendarButtonPreview = ({
  settings,
  globalSettings,
  activeProviders,
  providerLabels,
}) => {
  const buttonSize = Math.max(
    24,
    Math.min(72, Number(settings.calendarProviderLogoHeight) || 32)
  );
  const shape =
    settings.calendarProviderButtonShape === 'square' ? '20px' : '9999px';

  return (
    <div className="rounded-2xl border border-slate-200 bg-slate-50/80 p-5">
      <div
        className="rounded-2xl p-5 shadow-sm"
        style={{
          backgroundColor: settings.calendarButtonBackgroundColor || '#0f172a',
          color: settings.calendarButtonTextColor || '#ffffff',
        }}
      >
        <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p
              className="font-semibold"
              style={{ fontSize: `${Number(settings.calendarButtonFontSize) || 14}pt` }}
            >
              {settings.calendarButtonText || 'Add to calendar'}
            </p>
            <p className="mt-1 text-xs opacity-80">
              {settings.calendarEventTitle || settings.eventName || 'Calendar event'}
            </p>
            {(settings.calendarEventLocation || settings.eventLocation) && (
              <p className="text-xs opacity-80">
                {settings.calendarEventLocation || settings.eventLocation}
              </p>
            )}
          </div>
        </div>
        <div className="mt-4 flex flex-wrap gap-3">
          {activeProviders.map(option => {
            const providerLogo =
              settings.calendarProviderLogos?.[option.key] ||
              globalSettings?.imageUrls?.[providerImageKeys[option.key]] ||
              '';
            return (
              <div
                key={option.key}
                className="flex items-center gap-3 rounded-full bg-white/15 px-3 py-2"
              >
                <span
                  style={{
                    backgroundColor: '#ffffff',
                    color: option.color,
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: buttonSize,
                    height: buttonSize,
                    borderRadius: shape,
                    overflow: 'hidden',
                    flexShrink: 0,
                  }}
                >
                  {providerLogo ? (
                    <img
                      src={providerLogo}
                      alt={option.label}
                      style={{
                        width: buttonSize,
                        height: buttonSize,
                        objectFit: 'contain',
                      }}
                    />
                  ) : (
                    <ProviderIcon provider={option.key} />
                  )}
                </span>
                <span className="text-sm font-medium text-white">
                  {providerLabels[option.key] || option.label}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

const CalendarButtonSection = ({
  settings,
  onUpdate,
  onNavigate,
  regmailEnabled,
  globalSettings,
}) => {
  const includeCalendarButton = Boolean(settings.includeCalendarButton);
  const providers = {
    ...defaultProviders,
    ...(settings.calendarProviders || {}),
  };
  const providerLabels = settings.calendarProviderLabels || {};

  const handleField = (key, value) => {
    onUpdate(key, value);
  };

  const handleCalendarToggle = value => {
    handleField('includeCalendarButton', value);
    if (!value) {
      onNavigate(prevSectionKey());
    }
  };

  const handleProviderToggle = (key, checked) => {
    const next = { ...providers, [key]: checked };
    if (!Object.values(next).some(Boolean)) {
      next.apple = true;
    }
    onUpdate('calendarProviders', next);
  };

  const handleProviderLabelChange = (key, value) => {
    const trimmed = (value || '').trim();
    const next = { ...providerLabels };
    if (trimmed) {
      next[key] = trimmed;
    } else {
      delete next[key];
    }
    onUpdate('calendarProviderLabels', next);
  };

  const nextSectionKey = () => {
    if (settings.includeWalletButtons) return 'wallet';
    if (regmailEnabled) return 'regmailCustomization';
    return 'images';
  };

  const prevSectionKey = () =>
    settings.showCongressAppLinks ? 'congressAppLinks' : 'content';

  const disabled = !includeCalendarButton;
  const contentClasses = disabled
    ? 'mt-4 space-y-6 opacity-60 pointer-events-none'
    : 'mt-4 space-y-6';

  const activeProviders = providerOptions.filter(option => providers[option.key]);
  const showIcsSettings = providers.apple || providers.outlook;

  return (
    <>
      <FormGroup title="Add to Calendar Button">
        <ToggleSwitch
          label="Enable Add to Calendar button"
          checked={includeCalendarButton}
          onChange={handleCalendarToggle}
        />

        <div className={contentClasses}>
          <div className="space-y-3">
            <p className="text-sm font-semibold text-gray-700">Supported calendars</p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              {providerOptions.map(option => {
                const checked = providers[option.key];
                return (
                  <label
                    key={option.key}
                    className={`flex items-start gap-3 rounded-xl border px-3 py-2 transition-colors ${
                      checked
                        ? 'border-primary bg-primary/5 text-primary'
                        : 'border-slate-200 text-slate-700 hover:border-primary/40'
                    } ${disabled ? 'cursor-not-allowed opacity-80' : ''}`}
                  >
                    <input
                      type="checkbox"
                      className="mt-1"
                      checked={checked}
                      disabled={disabled}
                      onChange={e => handleProviderToggle(option.key, e.target.checked)}
                    />
                    <div className="flex items-start gap-3">
                      <span
                        style={{
                          backgroundColor: option.color,
                          color: '#fff',
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: 28,
                          height: 28,
                          borderRadius: '9999px',
                        }}
                      >
                        <ProviderIcon provider={option.key} />
                      </span>
                      <div>
                        <p className="text-sm font-semibold text-slate-800">{option.label}</p>
                        <p className="text-xs text-slate-500 mt-0.5">{option.helper}</p>
                      </div>
                    </div>
                  </label>
                );
              })}
            </div>
            {includeCalendarButton && activeProviders.length === 0 && (
              <p className="text-xs text-rose-500">
                Wähle mindestens einen Kalender aus, damit der Button angezeigt wird.
              </p>
            )}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <FormInput
              label="Headline Text"
              value={settings.calendarButtonText || ''}
              onChange={e => handleField('calendarButtonText', e.target.value)}
              placeholder="Add to calendar"
            />
            <div className="md:col-span-2 flex items-end">
              <p className="text-xs text-gray-500">
                Placement is controlled in Text Templates via <code>[[CALENDAR]]</code>.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <AdvancedColorInput
              label="Background Color"
              value={
                settings.calendarButtonBackgroundColor ||
                settings.linkColor ||
                '#00519e'
              }
              onChange={value => handleField('calendarButtonBackgroundColor', value)}
            />
            <AdvancedColorInput
              label="Text Color"
              value={settings.calendarButtonTextColor || '#ffffff'}
              onChange={value => handleField('calendarButtonTextColor', value)}
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Slider
              label="Headline Font Size"
              value={settings.calendarButtonFontSize || 14}
              onChange={value => handleField('calendarButtonFontSize', value)}
              min={10}
              max={24}
              unit="pt"
            />
            <div className="flex flex-col justify-center rounded-lg border border-dashed border-slate-300 bg-slate-50/60 px-3 py-2 text-xs text-slate-600">
              <span className="font-semibold text-slate-700 text-sm">
                Corner radius
              </span>
              <span>
                Uses the global container radius from the Appearance tab so every box matches.
              </span>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Slider
              label="Calendar Icon Size"
              value={settings.calendarProviderLogoHeight || 32}
              onChange={value => handleField('calendarProviderLogoHeight', value)}
              min={24}
              max={72}
            />
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Button Shape
              </label>
              <select
                value={settings.calendarProviderButtonShape || 'circle'}
                onChange={e => handleField('calendarProviderButtonShape', e.target.value)}
                className="form-select block w-full"
                disabled={disabled}
              >
                <option value="circle">Circle</option>
                <option value="square">Rounded Square</option>
              </select>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <FormInput
              label="Event Title"
              value={
                settings.calendarEventTitle ||
                settings.eventName ||
                'Event title'
              }
              onChange={e => handleField('calendarEventTitle', e.target.value)}
              placeholder="Event title"
            />
            <FormInput
              label="Event Location"
              value={settings.calendarEventLocation || ''}
              onChange={e => handleField('calendarEventLocation', e.target.value)}
              placeholder="Location or conferencing link"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <FormInput
              label="Start Date & Time"
              type="datetime-local"
              value={settings.calendarEventStart || ''}
              onChange={e => handleField('calendarEventStart', e.target.value)}
              placeholder="Select date & time"
            />
            <FormInput
              label="End Date & Time"
              type="datetime-local"
              value={settings.calendarEventEnd || ''}
              onChange={e => handleField('calendarEventEnd', e.target.value)}
              placeholder="Select date & time"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Description
            </label>
            <textarea
              value={settings.calendarEventDescription || ''}
              onChange={e => handleField('calendarEventDescription', e.target.value)}
              placeholder="Brief agenda or notes (optional)"
              className="form-input bg-transparent min-h-[96px]"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <FormInput
              label="Event Link (optional)"
              value={settings.calendarEventUrl || ''}
              onChange={e => handleField('calendarEventUrl', e.target.value)}
              placeholder="https://"
            />
            {showIcsSettings && (
              <FormInput
                label="ICS File Name"
                value={settings.calendarButtonFileName || 'event.ics'}
                onChange={e => handleField('calendarButtonFileName', e.target.value)}
                placeholder="event.ics"
              />
            )}
          </div>

          {activeProviders.length > 0 && (
            <div className="space-y-3">
              <p className="text-sm font-semibold text-gray-700">
                Display options for active calendars
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {activeProviders.map(option => (
                  <div
                    key={option.key}
                    className="rounded-xl border border-slate-200 bg-white/60 p-3 space-y-3"
                  >
                    <p className="text-sm font-semibold text-slate-700">
                      {option.label}
                    </p>
                    <FormInput
                      label="Display Text (optional)"
                      value={providerLabels[option.key] || ''}
                      onChange={e =>
                        handleProviderLabelChange(option.key, e.target.value)
                      }
                      placeholder={option.label}
                      disabled={disabled}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </FormGroup>
      <FormGroup title="Preview">
        <CalendarButtonPreview
          settings={settings}
          globalSettings={globalSettings}
          activeProviders={activeProviders}
          providerLabels={providerLabels}
        />
      </FormGroup>
      <NavButtons
        onPrev={() => onNavigate(prevSectionKey())}
        onNext={() => onNavigate(nextSectionKey())}
      />
    </>
  );
};

export default CalendarButtonSection;
